import { EstateProps, ProjectProps } from "types/estatesAndMap";
import { FirestoreActivityProps } from "types/firestoreFeatures";

export type ActivitySelectionOption = {
  projectId: string;
  activityId: string;
  activityName: string;
  label: string;
};

export const getActivitySelectionOptions = (
  activities: FirestoreActivityProps[] | null,
): ActivitySelectionOption[] => {
  if (!activities) return [];

  return activities
    .filter((activity) => activity.activityStatus !== "done")
    .map((activity) => ({
      projectId: activity.projectId,
      activityId: activity.id,
      activityName: activity.name,
      label: activity.name,
    }));
};

export const getReferencesFromSelectedFeature = (
  feature: any,
): { id: string; label: string }[] => {
  if (!feature) return [];

  if (feature.feature) {
    const { id, mapId, section, title, activityId } = feature.feature.properties;
    if (!mapId || !id || activityId) return [];
    const label = section && section.join("") !== "" ? section.join("") : title;
    return [{ id: `${mapId}/${id}`, label }];
  }

  if (feature.options) {
    const { id, mapId, section, title } = feature.options;
    if (!mapId || !id) return [];
    const label = section && section.join("") !== "" ? section.join("") : title;
    return [{ id: `${mapId}/${id}`, label }];
  }

  return [];
};

export const getEstateDataFromProjectId = (
  projectId: string | undefined,
  projects: Record<string, ProjectProps>,
  estates: Record<string, EstateProps>,
): EstateProps | undefined => {
  if (!projectId) return undefined;
  const project = projects[projectId];
  if (!project) return undefined;
  return estates[project.estateId];
};

export const getProjectDataFromProjectId = (
  projectId: string | undefined,
  projects: Record<string, ProjectProps>,
): ProjectProps | undefined => {
  if (!projectId) return undefined;
  return projects[projectId];
};
